export default "__VITE_ASSET__f660da27__"